import { HTTPMethod } from "http-method-enum";
import { ReasonPhrases, StatusCodes } from "http-status-codes";

import PhotoReviewsServiceClient from "clients/PhotoReviewsServiceClient";
import { withCdnCaching, CacheDurations } from "helpers/cache-control-helpers";

export default async function handler(req, res) {
  if (req.method !== HTTPMethod.GET) {
    res.status(StatusCodes.METHOD_NOT_ALLOWED).send(ReasonPhrases.METHOD_NOT_ALLOWED);
    return;
  }

  await handleReviewsCoverPhoto(req, res);
}

const PAGE_SIZE = 40;
const OFFSET = 0;

function getMomentWithCoverPhoto(momentWithCount) {
  const momentWithPhotos = momentWithCount?.moments;
  if (!Array.isArray(momentWithPhotos)) {
    return [];
  }

  const momentWithCoverPhotos = [];
  momentWithPhotos.map(momentWithPhoto => {
    const coverPhotoId = momentWithPhoto?.coverPhotoId;

    if (Number.isInteger(coverPhotoId) && Array.isArray(momentWithPhoto?.photos)) {
      const coverPhoto = momentWithPhoto.photos.find(o => o?.photoId === coverPhotoId);

      if (coverPhoto) {
        momentWithCoverPhotos.push({ ...momentWithPhoto, coverPhoto });
      }
    }
  });

  return { moments: momentWithCoverPhotos, totalCount: momentWithCount?.totalCount || 0 };
}

export async function fetchReviewsWithCoverPhoto(params, productId) {
  const momentWithPhotos = await PhotoReviewsServiceClient.getInstance().fetchMomentWithPhotos({
    limit: PAGE_SIZE,
    offset: OFFSET,
    ...params,
    styleName: productId,
  });

  return getMomentWithCoverPhoto(momentWithPhotos);
}

async function handleReviewsCoverPhoto(req, res) {
  const params = req.query;
  const productId = params.productId;
  delete params.productId;

  try {
    const photoReviews = await fetchReviewsWithCoverPhoto(params, productId);

    withCdnCaching(res, req, { "s-maxage": CacheDurations.LONG });
    res.status(StatusCodes.OK).json(photoReviews || []);
  } catch (e) {
    console.error(e);
    res.status(StatusCodes.INTERNAL_SERVER_ERROR).send(`Failed to fetch reviews for ${productId}`);
  }
}
